/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import {
  CHECK,
  LOGIN,
  LOGOUT,
  FIND,
} from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  [CHECK](state) {
    state.authenticated = !!localStorage.getItem('vue-token');
  },

  [LOGIN](state, keycloak) {
    state.authenticated = true;
    state.user = {};
    state.user.keycloak = keycloak;
    state.user.authenticated = true;
    state.user.idTokenParsed = keycloak.idTokenParsed;
    state.user.token = keycloak.token;
    state.user.idToken = keycloak.idToken;
    localStorage.setItem('vue-token', keycloak.token);
    localStorage.setItem('vue-refresh-token', keycloak.refreshToken);
  },

  [LOGOUT](state) {
    state.authenticated = false;
    state.user.idTokenParsed = '';
    state.user.token = '';
    state.user.idToken = '';
    state.user.role = '';
    state.user.group = {};
    localStorage.removeItem('vue-token');
    localStorage.removeItem('vue-refresh-token');
    state.user.keycloak.logout();
    state.user.keycloak = {};
    state.user.admin = false;
    state.user.isCompanyOwner = false;
  },

  [FIND](state, user) {
    state.user.firstname = user.firstname;
    state.user.lastname = user.lastname;
    state.user.email = user.email;
    state.user.admin = user.role === 'superuser';
    state.user.isCompanyOwner = user.group_users.some(groupUser => groupUser.group.group_owners.length > 0);
    state.admin = state.user.admin;

    if (user.group_users.length > 0) {
      state.user.group = user.group_users[0].group;
    }
  },
};
